module.exports = function() {
  return new Worker(__webpack_public_path__ + "f6de2ad9584c3464615a.worker.js");
};